import type { ValidationResult, YachtAction, YachtGameState } from "../types";
import { invalid } from "./common";
import { validateRollDice } from "./roll-dice";
import { validateScoreCategory } from "./score-category";
import { validateToggleHold } from "./toggle-hold";

export { validateRollDice } from "./roll-dice";
export { validateScoreCategory } from "./score-category";
export { validateToggleHold } from "./toggle-hold";

export function validateAction(
  state: YachtGameState,
  action: YachtAction,
): ValidationResult {
  switch (action.type) {
    case "ROLL_DICE":
      return validateRollDice(state, action);
    case "TOGGLE_HOLD":
      return validateToggleHold(state, action);
    case "SCORE_CATEGORY":
      return validateScoreCategory(state, action);
    default:
      return invalid("Unknown action");
  }
}
